import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { useContext } from 'react';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';
import { toastStore } from './toastStore';
import Toast from './Toast';
import { ToastWrapper } from './styles';

export const Toaster = () => {
  const toasts = useSyncExternalStore(toastStore.subscribe, toastStore.getSnapshot);
  const { isMobile: mobileTheme } = useContext(ThemeContext);

  return (
    <ToastWrapper isMobile={mobileTheme}>
      {toasts &&
        toasts.map((toast: any, index: any) => (
          <Toast key={toast.id} index={index} toast={toast} />
        ))}
    </ToastWrapper>
  );
};
